import React from 'react';

import { Shortcut } from './Shortcut';

const IS_MAC = window !== undefined && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
export const Cmd = () => <Shortcut>{IS_MAC ? '⌘' : 'Ctrl'}</Shortcut>;
